import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AgentFileUploadInputComponent } from './agent-file-upload-input/agent-file-upload-input.component';
import { UiModule } from '@irembo-andela/irembogov3-common';
import { SearchboxComponent } from './searchbox/searchbox.component';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { Observable, catchError, finalize, of } from 'rxjs';
import { environment } from '../../../environments/environment';
import { LocaleService } from '../../core/services/locale/locale.service';
import { FormatFileNamePipe } from '../../core/filters/format-file-name/format-file-name.pipe';

export function HttpLoaderFactory(
  http: HttpClient,
  localeService: LocaleService
) {
  return new CustomLoader(http, localeService);
}
export class CustomLoader implements TranslateLoader {
  constructor(
    private httpClient: HttpClient,
    private localeService: LocaleService
  ) {}
  getTranslation(lang: string): Observable<any> {
    const header = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    const apiAddress = `${environment.translationSourceUrl}/admin/v1/translations/static-text/by-locale/${lang}`;
    if (!this.localeService.translationsLoadedBefore) {
      this.localeService.loadingTranslations.next(true);
    }
    return this.httpClient.get(apiAddress, { headers: header }).pipe(
      finalize(() => {
        this.localeService.loadingTranslations.next(false);
        this.localeService.translationsLoadedBefore = true;
      }),
      catchError(() => {
        // Return an empty object to trigger missing translation handler
        return of({});
      })
    );
  }
}

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    UiModule,
    TranslateModule.forChild({
      // defaultLanguage:
      // localStorage.getItem('locale') ?? environment.DEFAULT_LOCALE,
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient, LocaleService],
      },
    }),
    AgentFileUploadInputComponent,
    SearchboxComponent,
    FormatFileNamePipe,
  ],
  exports: [
    AgentFileUploadInputComponent,
    SearchboxComponent,
    TranslateModule,
    FormatFileNamePipe,
  ],
})
export class SharedModule {
  static forRoot() {
    return {
      ngModule: SharedModule,
    };
  }
}
